import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProjectCard from './ProjectCard';

import './Page.css';
import 'bootstrap/dist/css/bootstrap.min.css';


const Page = ({ projects }) => {

  return (
    <>
      <div className="content-container">
        <Row className="align-items-center" id="introduction-pg" title="Black Sand">
          <Col md="12">
            <h1>Kayla Elias</h1>
            <h2>Software Engineer</h2>
          </Col>
        </Row>

        <Container>
          <Row id="about-me-pg" className="page-spacing">
            <Col md="12"><h1>About Me</h1></Col>
            <Col md="12">
              <p>I am a Software Engineer with a B.S. in Computer Science from the University of California, Irvine (UCI), but it didn't start out that way. Up until college, I was pursuing Musical Theater, but taking honors classes on the side. It wasn't until Musical Theater became my major and focus, that I realized I needed something more intellectually challenging. I browsed the majors, taking a variety of classes from different areas of study, until a "snake" caught my eye. Python was my first programming language and that's how I got wrapped up in computer science.</p>
              <p>After graduation, I got a job as a Junior Data Engineer at Melissa Data in Rancho Santa Margarita. I learned a lot about data manipulation and different database managerment systems. Unfortunately, a few months after starting, I was forced to move back to Los Angeles due to family circumstances.</p>
              <p>Currently, I work as a Survey Engineer at LRW, a Material+ Company. I design, program, and process data for all kinds of market research surveys, using React, HTML, JavaScript, CSS, and mrScript. On the side, I am still adding skills to my wheel-house by taking web development classes at Los Angeles Pierce College and Santa Monica Community College working towards obtaining my Web Development Certificate.</p>
              <p className="signature">- Kayla Elias, April 2019</p></Col>
          </Row>

          <Row id="experience-pg" className="page-spacing">
            <Col md="12"><h1>Experience</h1></Col>
            <Col xs="12" md="7">
              <h2>Survey Engineer</h2>
              <div className="locations-and-dates">April 2019 – Present || LRW, Century City, CA</div>
              <p>Designed, programmed, and processed data for market research surveys using React, HTML, JavaScript, CSS, and Unicom Intelligence Products (i.e. mrStudio, DimensionNet).</p>
              <h2>Junior Data Engineer</h2>
              <div className="locations-and-dates">October 2015 – April 2016 || Melissa Data, Rancho Santa Margarita, CA</div>
              <p>Created tools and programs to extract, transform, and load data across different database systems including Microsoft SQL Server and Apache Cassandra.</p>
              <h2>GUI Internship</h2>
              <div className="locations-and-dates">January 2015 – March 2015 || Conexant, Irvine, CA</div>
              <p>Created an audio tuning GUI for sound output to simplify the use of Conexant’s command-based system.</p>
              <h2>Trainer</h2>
              <div className="locations-and-dates">July 2012 – April 2019 || California Pizza Kitchen, Woodland Hills, CA</div>
              <p>Trained new hires in efficient service. Handled multiple tasks in a fast-paced environment, while maintaining a high degree of accuracy.</p>
            </Col>
            <Col xs="12" md="4" className="divider-line">
              <Row>
                <Col xs="12" md="12">
                  <h2>Classes</h2>
                  <div className="classes-styling"><h3>PHP Programming</h3><div className="locations-and-dates">February 2020 || Santa Monica Community College, Santa Monica, CA</div></div>
                  <div className="classes-styling"><h3>Web Dev using HTML &amp; JavaScript</h3><div className="locations-and-dates">February 2019 || Pierce College, Woodland Hills, CA</div></div>
                  <div className="classes-styling"><h3>Introduction to Web</h3><div className="locations-and-dates">September 2018 || Pierce College, Woodland Hills, CA</div></div>
                </Col>
                <Col xs="6" md="6">
                  <h2>Skills</h2>
                  <ul>
                    <li>Java</li>
                    <li>Python</li>
                    <li>HTML/CSS</li>
                    <li>React</li>
                  </ul>
                </Col>
                <Col xs="6" md="6">
                  <h2 className="hidden-text">[hidden]</h2>
                  <ul>
                    <li>Documentation</li>
                    <li>Communication</li>
                    <li>Organization</li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row id="projects-pg" className="page-spacing">
            <Col><h1>Projects</h1></Col>
            <Row className="projects-cards">
              {projects.map((index) =>
                <ProjectCard key={index.projectName} {...index}></ProjectCard>
              )}
            </Row>
          </Row>
        </Container>
      </div>
    </>

  );
}


export default Page;
